import { render, staticRenderFns } from "./surveyOverview.vue?vue&type=template&id=8ed12d6c&scoped=true"
import script from "./surveyOverview.vue?vue&type=script&lang=js"
export * from "./surveyOverview.vue?vue&type=script&lang=js"
import style0 from "./surveyOverview.vue?vue&type=style&index=0&id=8ed12d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed12d6c",
  null
  
)

export default component.exports